export const SRP_ERRORS = {
    LOGIN_ERRORS: {
        GRAPHQL_FAILED: 'GRAPHQL_FAILED',
        PAGEJSON_FAILED: 'PAGEJSON_FAILED'
    }
}